export enum ADMIN_ROUTES {
  // ADMIN/SETTINGS
  ADMIN_SETTINGS = 'settings/general',
  ADMIN_TRANSLATIONS = 'settings/translations',
  ADMIN_API = 'settings/api',
  ADMIN_PAGES_SETTINGS = 'settings/pages',
  ADMIN_MECHANICAL_COMPONENTS = 'settings/mechanical-components',
  ADMIN_WIDGET_LAYOUT = 'settings/widget-layout',
  ADMIN_GAUGE_LAYOUT = 'settings/gauge-layout',
  ADMIN_MECHANICAL_COMPONENT_LAYOUT = 'settings/mechanical-components/layout',

  // ADMIN/TV
  ADMIN_PAGES_CONFIG = 'tv/pages-config',
  ADMIN_TVMODE_CLIENTS = 'tv/clients',
  ADMIN_WIDGET_LAYOUT_TV = 'tv/widget-layout',

  ATV_SETTINGS_PRESENTATIONS = 'apple-tv/presentations',
  ATV_SETTINGS_PRESENTATION_EDITOR = 'apple-tv/presentations/:presentationId/editor',
  ATV_SETTINGS_CLIENTS = 'apple-tv/clients',

  ADMIN_TVMODE_3D = 'tv_mode/3d',

  // ADMIN/DATA-SOURCES
  ADMIN_MODBUS_CONFIG = 'data-sources/modbus',
  ADMIN_NMEA = 'data-sources/nmea',
  ADMIN_AIS = 'data-sources/ais',

  // ADMIN/GUEST
  ADMIN_TRIPS = 'guest/trips',
  ADMIN_TRIPS_CREATE = 'guest/trips-create',
  ADMIN_TRIPS_EDIT = 'guest/trips-edit/:id',
  ADMIN_CREW = 'guest/crew',
  ADMIN_FOOD_MANAGEMENT = 'guest/food-management',
  ADMIN_GALLERY = 'guest/gallery',
  ADMIN_GALLERY_VIEW = 'guest/gallery-details/:id',
  ADMIN_NOTIFICATION = 'guest/notification',
  ADMIN_TIMEZONES = 'guest/timezones',
  ADMIN_WEATHER = 'guest/weather',
  GALLERY_DETAILS = 'guest/gallery-details',
  ADMIN_WIDGET = 'guest/widgets',
  ADMIN_AGENDA = 'guest/agenda',

  // ADMIN/DETAILS
  ADMIN_IMAGE_UPLOAD = 'details/media-management',
  ADMIN_YACHT_INFORMATION = 'details/information-page',
  ADMIN_YACHT_GALLERY_DETAILS = 'details/information-page-gallery',
  ADMIN_YACHT_GALLERY_VIEW = 'details/information-page-gallery/:id',
  ADMIN_3D_MODEL_SETTINGS = 'details/3d-model',

  // ADMIN/PRESENTATIONS
  ADMIN_PRESENTATIONS = 'settings/presentations',

  // ADMIN/* (REST)
  ADMIN_MODBUS_ADDRESS = 'modbusaddress',
  ADMIN_INDEXJSON = 'index/edit',
  ADMIN_PAGESJSON = 'pages/edit',
  ADMIN_THEME = 'theme/change',
  ADMIN_ERRORS = 'errors',
  ADMIN_LIVE_LOG_VIEWER = 'support/live-log-viewer',
}

export enum ROUTES {
  // HOME
  HOME = '/home',
  TIMES = '/home/times',
  SPEED_DISTANCE = '/home/speed_distance',
  DEPTH = '/home/depth',
  BAROMETRIC_PRESSURE = '/home/barometric_pressure',
  WIND = '/home/wind',
  INFO = '/home/info',
  WEATHER = '/home/weather',
  DISTANCE = '/home/distance',
  MEKKAH = '/home/mekkah',
  TEMPERATURES = '/home/temperatures',

  // DETAILS
  THREE_D = '/details/3d_view',
  SAT_ANTENNAS = '/details/mechanical-components/sat_antennas/',
  SAT_ANTENNA = '/details/mechanical-components/sat_antennas/:id',
  PROPELLERS = '/details/mechanical-components/propellers',
  RUDDER = '/details/mechanical-components/rudder',
  THRUSTER = '/details/mechanical-components/thruster',
  GEARBOX = '/details/mechanical-components/gearbox',
  CHILLER = '/details/mechanical-components/chiller',
  ENGINES = '/details/mechanical-components/engines',
  SAFETY_PLAN = '/details/safety',
  YACHT_PAGE = '/details/yacht',
  WATERMAKERS = '/details/mechanical-components/watermakers',
  GENERATORS = '/details/mechanical-components/power',
  TANKS = '/details/mechanical-components/tanks',
  STABILIZERS = '/details/mechanical-components/stabilizers',
  DETAILS = '/details/mechanical-components',

  // PDF
  PDFS = '/pdf/',
  PDF = '/pdf/:index',

  // GALLERY
  GALLERIES = '/gallery',
  GALLERY = '/gallery/:id',

  // INFO_CHANNEL
  INFO_CHANNELS = '/info_channel/',
  INFO_CHANNEL = '/info_channel/:index',

  //PRESENTATIONS
  PRESENTATIONS = '/presentations/:presentationId/:presentationIndex',

  // * (REST)
  MAP = '/map',
  VIDEO = '/demo',
  CALENDAR = '/calendar',
  TRIP = '/trip',
  CREW = '/crew',
  ADMIN = '/admin/*',
  PINCODE = '/pincode',
  BATTERY = '/details/mechanical-components/battery',
  ECO_SCORE = '/home/eco-score',
}
